import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/restaurants/availability.ts
import { Exception } from "@wbk/logger";
var getSevenRoomsAvailability = (props) => __async(void 0, null, function* () {
  try {
    const params = new URLSearchParams(__spreadProps(__spreadValues({}, props), {
      table_numbers: props.table_numbers.join(","),
      party_size: props.party_size.toString()
    })).toString();
    const url = `/sevenrooms/availability?${params}`;
    const data = yield fetchClient({
      url
    });
    if (data.status !== "success") {
      throw new Error((data == null ? void 0 : data.message) || "Something went wrong");
    }
    return data.data.availability;
  } catch (err) {
    throw new Exception({
      error: err,
      name: "getSevenRoomsAvailabilityException"
    });
  }
});

export {
  getSevenRoomsAvailability
};
//# sourceMappingURL=chunk-5YESQLVX.mjs.map